export const AdminActivityLogController = {
    index(): void {},
};
